// Telegram Notification Service
const TELEGRAM_BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN || '8331042690:AAHYV-w4SpuUPCU4blw758xAX0KHdLuGQtI';
const TELEGRAM_CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT_ID || '7327753340';

export const sendTelegramNotification = async (bookingData) => {
  try {
    // Format the message
    const message = formatBookingMessage(bookingData);
    
    // Send to Telegram
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: TELEGRAM_CHAT_ID,
        text: message,
        parse_mode: 'HTML'
      })
    });

    if (!response.ok) {
      throw new Error(`Telegram API error: ${response.status}`);
    }

    return { success: true };
  } catch (error) {
    console.error('Telegram notification failed:', error);
    return { success: false, error: error.message };
  }
};

const formatBookingMessage = (data) => {
  const timestamp = new Date().toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  return `
🚗 <b>New Taxi Booking Request</b>

📍 <b>From:</b> ${data.pickupLocation}
📍 <b>To:</b> ${data.dropoffLocation}
📏 <b>Distance:</b> ${data.distance} km
🚙 <b>Vehicle:</b> ${data.vehicleType.toUpperCase()}
🔄 <b>Trip Type:</b> ${data.tripType === 'oneway' ? 'One Way' : 'Round Trip'}

👤 <b>Customer Details:</b>
• Name: ${data.customerName}
• Phone: ${data.customerPhone}

📅 <b>Pickup:</b> ${data.pickupDate} at ${data.pickupTime}
${data.tripType === 'roundtrip' && data.returnDate ? `📅 <b>Return:</b> ${data.returnDate}` : ''}

⏰ <b>Requested at:</b> ${timestamp}

💰 <b>Estimated Fare:</b> ₹${data.estimatedFare ? data.estimatedFare.toFixed(2) : 'Calculating...'}

 <b>Note:Toll fees, hills charges, Parking charges and Inter-State Permit charges (if any) are extra.</b>
---
<i>This is an automated notification from your taxi booking website.</i>
  `.trim();
};

export default sendTelegramNotification;
